import { Component, Inject, Input, OnInit } from '@angular/core';
import { DisbursementExclusions } from '../applications/application/disbursement.exclusions';
import { Results } from '../core/results';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-disbursement-exclusion',
  templateUrl: './disbursement-exclusion.component.html',
  styleUrls: ['./disbursement-exclusion.component.scss']
})
export class DisbursementExclusionComponent implements OnInit {

    @Input() disbursementExclusions: Results<DisbursementExclusions> = new Results<DisbursementExclusions>()
    
    constructor(@Inject(MAT_DIALOG_DATA) public data: Results<DisbursementExclusions>) {
    }

  ngOnInit(): void {  
    console.log(this.data);
    this.disbursementExclusions = this.data;
  }

}
